<script setup>
import { watch, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useFirstScroll } from "../utils/useFirstScroll";
import { usePopupStackStore } from "../store/popupStack";
import { storeToRefs } from "pinia";
import PopupIcon from "@/assets/popup-icon.png";
import PopupIcon1 from "@/assets/popup-icon-1.png";
import HelpImage from "@/assets/help-image.jpg";
import WxLaunchAppBtn from "./WxLaunchAppBtn.vue";

const { stack } = storeToRefs(usePopupStackStore());
const { pushStack } = usePopupStackStore();

const route = useRoute();

/**
 * initPopup: 初次是否弹窗
 */
const { initPopup = false, appParams } = defineProps([
  "initPopup",
  "appParams",
]);

const emit = defineEmits(["confirm"]);

const { firstScroll } = useFirstScroll();
const show = ref(false);

const canPopup = computed(() => {
  return !stack.value.includes(route.path);
});

watch(
  () => firstScroll.value,
  (val) => {
    if (val && !initPopup && canPopup.value) {
      show.value = true;
    }
  },
);

watch(
  () => initPopup,
  (val) => {
    if (val && canPopup.value) {
      show.value = true;
    }
  },
  {
    immediate: true,
  },
);

watch(
  () => show.value,
  (val) => {
    if (val) {
      // pushStack(route.path);
    }
  },
  {
    immediate: true,
  },
);

const handleConfirm = () => {
  emit("confirm");
};

const handleCancel = () => {
  show.value = false;
};

const handleHelp = () => {
  show.value = false;
  showImagePreview({
    images: [HelpImage],
    showIndex: false,
    className: "__help-img-preview",
    onClose: () => {
      show.value = true;
    },
  });
};

const handleToHome = () => {
  window.location.href = "https://banxueketang.com/";
};
</script>

<template>
  <van-overlay :show="show" @click="show = true" z-index="3500">
    <div class="wrapper">
      <div class="block" @click.stop>
        <div class="container">
          <div class="container-header">
            <van-image :src="PopupIcon1" class="header-icon" />
            <div class="header-info">
              <span class="header-info-title">伴学课堂</span>
              <div class="header-info-subtitle">斗半匠官方APP</div>
            </div>
          </div>

          <div class="container-text">
            由于网页版学习体验的局限性，我们建议您在<span
              class="container-text-highlight"
              >伴学课堂</span
            >App内使用音、视频、资料等配套资源。
          </div>

          <div class="container-btns">
            <div class="container-btns-cancel" @click="handleCancel">
              <div>网页体验</div>
              <div class="container-btns-cancel-subtitle">下次仍需扫码</div>
            </div>

            <div class="container-btns-location" @click="handleConfirm">
              APP内打开
            </div>
            <!-- <div class="container-btns-help" @click="handleHelp">使用帮助</div>
            <div class="container-btns-confirm" @click="handleToHome">
              官网下载
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  box-sizing: border-box;
  width: 319px;
  padding: 24px 24px 12px;
  background-color: #fff;
  border-radius: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #fff;
  background-image: url("@/assets/popup-bg.png");
  background-size: auto 160px;
  background-repeat: no-repeat;
}

.container {
  width: 100%;
  .container-text {
    font-size: 16px;
    line-height: 24px;
    color: #000000d9;
    font-weight: 400;
    margin-bottom: 32px;
  }
  .container-text-highlight {
    margin: 0 4px;
    color: #ff8912ff;
    font-weight: 600;
  }
  .container-btns {
    height: 40px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #00000059;

    // .container-btns-cancel,
    // .container-btns-help,
    // .container-btns-confirm {
    //   width: 4em;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   white-space: nowrap;
    // }
    .container-btns-cancel {
      padding: 0 22px;
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      font-size: 14px;
      background-color: #f7f7f7;
      color: #000000d9;
      cursor: pointer;
    }
    .container-btns-cancel-subtitle {
      font-size: 9px;
      line-height: 10px;
      color: #00000059;
    }

    .container-btns-location {
      margin-left: 8px;
      flex: 1;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      background: linear-gradient(90deg, #ffa431ff 0%, #ff8912ff 100%);
      cursor: pointer;
    }
  }
  .container-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .header-icon {
      width: 72px;
      height: 72px;
    }
    .header-info {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      .header-info-title {
        font-size: 20px;
        line-height: 28px;
        color: #000000d9;
        margin-bottom: 4px;
        font-weight: 600;
      }
      .header-info-subtitle {
        font-size: 14px;
        line-height: 22px;
        color: #724117ff;
        padding: 2px 8px;
        border-radius: 6px;
        background: linear-gradient(
          86.74deg,
          #ffebcfff 3.08%,
          #fcd9b4ff 97.85%
        );
      }
    }
  }
}
</style>

<style lang="scss">
.__help-img-preview {
  z-index: 4000 !important;
}
</style>
